import { css } from '@/styled-system/css';

export const dropdownBodyStyles = css.raw({
  'paddingBlock': 'default',
  'paddingInline': 'default',
  'overflowY': 'auto',
  'flexGrow': 1,
  'flexShrink': 1,
  'flexBasis': 'auto',

  '& > .c11n_dropdown__heading:first-child': {
    borderStartStartRadius: 'obj.soft',
    borderStartEndRadius: 'obj.soft',
    marginBlockStart: 'calc(-1 * {spacing.default})',
  },

  '& > .c11n_dropdown__heading': {
    marginInline: 'calc(-1 * {spacing.default})',
  },
});
